import { PASSWORD_MIN_LENGTH } from '../../utils/passwordSecurity';

const REQUIREMENTS = [
  ['length', `Al menos ${PASSWORD_MIN_LENGTH} caracteres`],
  ['uppercase', 'Una mayúscula'],
  ['lowercase', 'Una minúscula'],
  ['number', 'Un número'],
  ['symbol', 'Un símbolo'],
];

const RequirementItem = ({ valid, children }) => (
  <div className={`password-requirement ${valid ? 'is-valid' : ''}`}>
    <span aria-hidden='true'>{valid ? '✓' : '○'}</span>
    <span>{children}</span>
  </div>
);

export default function PasswordSecurityFeedback({
  checks,
  strength,
}) {
  return (
    <>
      <div className='password-strength'>
        <div className='password-strength-header'>
          <span>Seguridad</span>
          <span>{strength.label}</span>
        </div>

        <div className='password-strength-track'>
          <div
            className={`password-strength-fill ${strength.className}`}
          />
        </div>
      </div>

      <div className='password-requirements'>
        {REQUIREMENTS.map(([key, label]) => (
          <RequirementItem
            key={key}
            valid={Boolean(checks?.[key])}
          >
            {label}
          </RequirementItem>
        ))}
      </div>
    </>
  );
}
